import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const onSearch = (event: FormEvent) => {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/gossip?q=${encodeURIComponent(q)}` : '/gossip');
  };

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20stylized%20stage%20with%20warm%20coral%20and%20amber%20spotlights%2C%20floating%20confetti%20and%20soft%20haze%2C%20theater%20curtain%20texture%2C%20dark%20moody%20edges%2C%20cinematic%20entertainment%20atmosphere%2C%20no%20text&width=1800&height=1000&seq=baogua-hero-main&orientation=landscape"
          alt="爆瓜福利 娱乐吃瓜资讯与分享社区"
          title="爆瓜福利 - 吃瓜爆料与分享社区"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/60 to-foreground-950/40"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-6xl flex-col justify-center px-4 py-20 md:px-6 md:py-28">
        <span className="inline-flex w-fit items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur">
          <i className="ri-fire-fill text-secondary-400"></i>
          今日新瓜已更新 · 12 条
        </span>
        <h1 className="mt-6 max-w-2xl font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl md:leading-tight">
          吃瓜不必东奔西走
          <br />
          爆瓜福利帮你聚合
        </h1>
        <p className="mt-5 max-w-xl text-sm leading-7 text-background-100/90 md:text-base md:leading-8">
          我们把全网最值得一看的娱乐爆料、明星动态与影视综艺热议整理在一起，并汇聚分享帖、分享群、分享链接与分享码资源，让你打开一个网站就能跟上所有热点。
        </p>

        <form onSubmit={onSearch} className="mt-8 flex w-full max-w-xl flex-col gap-3 sm:flex-row">
          <div className="flex flex-1 items-center gap-2 rounded-md bg-background-50 px-4 py-3">
            <i className="ri-search-line text-lg text-foreground-400"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索明星、剧名或话题关键词"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </div>
          <button
            type="submit"
            className="whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            开始吃瓜
          </button>
        </form>

        <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-3 text-sm text-background-100/80">
          <span className="flex items-center gap-2">
            <i className="ri-article-line text-secondary-400"></i>
            累计收录 1,286 篇爆料
          </span>
          <span className="flex items-center gap-2">
            <i className="ri-group-line text-secondary-400"></i>
            18 个分享社群
          </span>
          <span className="flex items-center gap-2">
            <i className="ri-refresh-line text-secondary-400"></i>
            每日实时更新
          </span>
        </div>
      </div>
    </section>
  );
}